import { PayloadAction, createSlice, nanoid } from '@reduxjs/toolkit';
import { LegalTab, State, ToastStatus, WelcomeStep } from './types';
import { getJobInfoThunk, uploadFileThunk } from './thunks';

const initialState: State = {
    notification: [],
    welcomeStep: 'Initial',
    fileId: null,
    jobInfo: null,
    jobInfoLoading: true,
    legalTab: 'Privacy_Policy',
    smallScreenWarningModal: false,
};

export const generalSlice = createSlice({
    name: 'general',
    initialState,
    reducers: {
        setWelcomeStep: (state, action: PayloadAction<WelcomeStep>) => {
            state.welcomeStep = action.payload;
        },
        setNotification: (state, action: PayloadAction<[string, ToastStatus]>) => {
            const toastProps = {
                id: nanoid(),
                message: action.payload[0],
                status: action.payload[1]
            };

            state.notification.push(toastProps);
        },
        removeNotification: (state) => {
            state.notification.shift();
        },
        setLegalTab: (state, action: PayloadAction<LegalTab>) => {
            state.legalTab = action.payload;
        },
        setSmallScreenWarningModal: (state, action: PayloadAction<boolean>) => {
            state.smallScreenWarningModal = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(uploadFileThunk.pending, (state, action) => {
                state.fileId = action.payload;
            })
            .addCase(getJobInfoThunk.fulfilled, (state, action) => {
                state.jobInfo = action.payload;
                state.jobInfoLoading = false;
            })
            .addCase(getJobInfoThunk.pending, (state) => {
                state.jobInfoLoading = true;
            })
            .addCase(getJobInfoThunk.rejected, (state) => {
                state.jobInfoLoading = false;
            })
    }
});

export const {
    setLegalTab,
    setWelcomeStep,
    setNotification,
    removeNotification,
    setSmallScreenWarningModal,
} = generalSlice.actions;